'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
require('prop-types');
var TruncateText = require('../../../../utils/TruncateText.js');
var Typography = require('../../Typography/Typography.js');
var withStyles = require('../../../Styles/withStyles.js');
var ExpandableTableCell = require('../ExpandableTableCell.js');
var ClipboardWrapper = require('../../../../utils/ClipboardWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  minimumHeight: {
    minHeight: ExpandableTableCell.TWO_ROW_HEIGHT
  }
};

var AddressTextTableCellContent = function AddressTextTableCellContent(_ref) {
  var classes = _ref.classes,
      _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      truncate = _ref.truncate,
      maxLines = _ref.maxLines,
      dependencies = _ref.dependencies,
      children = _ref.children,
      copyable = _ref.copyable,
      props = objectWithoutProperties(_ref, ["classes", "wrapperComponent", "wrapperProps", "truncate", "maxLines", "dependencies", "children", "copyable"]);

  var firstCommaIndex = children ? children.indexOf(',') : -1;
  var skipCommaAndSpaceOffset = 2;

  var className = wrapperProps.className,
      otherWrapperProps = objectWithoutProperties(wrapperProps, ["className"]);

  var AddressText = function AddressText() {
    return firstCommaIndex === -1 ? React__default["default"].createElement(Typography, _extends["default"]({
      variant: "body2"
    }, props), React__default["default"].createElement(TruncateText, {
      truncate: truncate,
      maxLines: maxLines,
      dependencies: dependencies
    }, children)) : React__default["default"].createElement("div", null, React__default["default"].createElement(Typography, _extends["default"]({
      variant: "body1"
    }, props), React__default["default"].createElement(TruncateText, {
      truncate: truncate,
      maxLines: maxLines,
      dependencies: dependencies
    }, children.substring(0, firstCommaIndex))), React__default["default"].createElement(Typography, _extends["default"]({
      variant: "body1"
    }, props), React__default["default"].createElement(TruncateText, {
      truncate: truncate,
      maxLines: maxLines,
      dependencies: dependencies
    }, children.substring(firstCommaIndex + skipCommaAndSpaceOffset))));
  };

  return React__default["default"].createElement(Wrapper, _extends["default"]({
    className: classNames__default["default"](classes.minimumHeight, className)
  }, otherWrapperProps), copyable ? React__default["default"].createElement(ClipboardWrapper, {
    textToCopy: children
  }, React__default["default"].createElement(AddressText, null)) : React__default["default"].createElement(AddressText, null));
};

var AddressTextTableCellContent$1 = withStyles["default"](styles)(AddressTextTableCellContent);

module.exports = AddressTextTableCellContent$1;
